<template>
    <a-spin id="LookReport" :spinning="boxSpinning">
        <a-card title="基本信息" :bordered="false">
            <a-page-header style="border: 1px solid rgb(235, 237, 240);margin-bottom: 30px;"
                           :title="reportInfo.name"
                           :backIcon="false">
                <template slot="extra">
                    <a-button v-if="!reportInfo.reportUri" type="link" key="3">
                        报告生成中
                    </a-button>
                    <a-button v-else type="primary" ghost key="2">
                        <a download :href="reportInfo.reportUri">下载报告</a>
                    </a-button>
                </template>
                <a-descriptions size="small" :column="3">
                    <a-descriptions-item label="报告模板">
                        {{ reportInfo.reportTemplateName }}
                    </a-descriptions-item>
                    <a-descriptions-item label="报告能力">
                        {{ reportInfo.abilityName}}
                    </a-descriptions-item>
                    <a-descriptions-item label="来源机构">
                        {{ reportInfo.organizationName }}
                    </a-descriptions-item>
                    <a-descriptions-item label="创建时间">
                        {{ reportInfo.createTime }}
                    </a-descriptions-item>
                </a-descriptions>
            </a-page-header>
        </a-card>
        <a-card title="课程信息" :bordered="false">
            <div class="table">
                <a-table
                    :columns="columns"
                    :pagination="false"
                    rowKey="id"
                    :data-source="collapseList">
                        <span slot="progress" slot-scope="text, record">
                            <a-progress :percent="text" size="small"/>
                        </span>
                        <span slot="status" slot-scope="text, record">
                            <span v-if="text" style="color:#009688;">启用</span>
                            <span v-else style="color: #f00">禁用</span>
                        </span>
                </a-table>
            </div>
        </a-card>
        <a-card title="学生信息" :bordered="false">
            <a-spin :spinning="tableRelevant.tableLoading" id="StepsSecond">
                <div class="left hideScroll">
                    <a-tree
                        defaultExpandAll
                        :key="tree.key"
                        @select="treeCheck"
                        :replaceFields="{title:'name', key:'id'}"
                        :tree-data="tree.treeAllData">
                        <span slot="title" slot-scope="value">
                            {{value.name}}
                            （{{value.selectStuNum + value.add.length - value.del.length}}
                            / {{value.userCount}}）
                        </span>
                    </a-tree>
                </div>
                <div class="right hideScroll">
                    <a-table :columns="Studentcolumns"
                            :row-key="text => text.classUserId"
                            :pagination="tableRelevant.tablePagination"
                            :dataSource="tableRelevant.tableDataSource">
                            <div slot="classNames" slot-scope="text, record">
                                {{text.gradeName}}{{text.className}}
                            </div>
                            <div slot="gender" slot-scope="text, record">
                                {{text.gender == 0 ? '女' : '男'}}
                            </div>
                            <div slot="birthday" slot-scope="text, record">
                                {{text.birthday.split(' ')[0]}}
                            </div>
                            <div slot="courseName" slot-scope="text, record">
                                <div class="self_td" v-for="item in text.userCourses" :key="item.id">{{item.projectCourseConfigName}}</div>
                            </div>
                            <div slot="progress" slot-scope="text, record">
                                <div class="self_td" v-for="item in text.userCourses" :key="item.id">{{item.progress}}%</div>
                            </div>
                            <div slot="status" slot-scope="text, record">
                                <div class="self_td" v-for="item in text.userCourses" :key="item.id">
                                    {{item.progress == 0 ? '未开始' : item.progress == 100 ? '已完成' : '进行中'}}
                                </div>
                            </div>
                    </a-table>
                </div>
            </a-spin>
        </a-card>
    </a-spin>
</template>

<script>
    import $Bus from "@/pages/projectImpl/js/eventBus";
    import { tableRelevant } from '@/pages/projectImpl/js/utils'
    const columns = [
        {
            title: '课程名称',
            dataIndex: 'organizationCourseName',
            ellipsis: true,
            align:'center'
        },
        {
            title: '进行状态',
            dataIndex: 'progress',
            scopedSlots: {customRender: 'progress'},
            align:'center'
        },
        {
            title: '状态',
            dataIndex: 'enabled',
            scopedSlots: {customRender: 'status'},
            align:'center'
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align:'center'
        },
    ];
    const Studentcolumns = [
        { title: '学生', dataIndex: 'realName' },
        { title: '班级', scopedSlots: {customRender: 'classNames'}},
        { title: '性别', scopedSlots: {customRender: 'gender'}},
        { title: '出生日期', scopedSlots: {customRender: 'birthday'}},
        { title: '课程名称',class:'testClass', scopedSlots: {customRender: 'courseName'}},
        { title: '个人进度',class:'testClass', scopedSlots: {customRender: 'progress'}},
        { title: '个人状态',class:'testClass', scopedSlots: {customRender: 'status'}},
    ]
    export default {
        name: "LookReport",
        props: {reportInfo: {}},
        data() {
            return {
                boxSpinning: false,
                reportTemplate: {},
                //课程列表
                collapseList: [],
                columns,

                searchForm: {
                    userName: '',
                    courseCount: '',
                    statuss:undefined,
                    gradeId: undefined,
                    classId: undefined,
                    projectCourseConfigId: this.$store.getters["course/getEditCourse"]().id
                },
                Studentcolumns,
                //表格相关
                tableRelevant: tableRelevant.call(this),
                //树相关
                tree: {
                    key: Date.now(),
                    treeData: [],
                    treeAllData: [],
                }
            }
        },
        mounted() {
            console.log(this.reportInfo);
            this.getCourseList()
        },
        methods: {
            // 已添加课程列表
            getCourseList(){
                let params = {
                    pageSize:9999,
                    pageIndex:1,
                    combinationReportId:this.reportInfo.id,
                    organizationId:this.reportInfo.organizationId,
                }
                this.boxSpinning = true;
                this.$http.GroupReport.addCourseList(params)
                .then(res => {
                    this.collapseList = res.data.items
                    let arr = []
                    this.collapseList.forEach(v=>{
                        arr.push(v.organizationCourseId)
                    })
                    this.$store.commit('organization/setReportCourse', arr);
                    this.getTreeData()
                }).finally(() => {
                  this.boxSpinning = false
                })
            },
            //树复选框选中或取消
            treeCheck(checkedKeys, e) {
                const value = e.node.dataRef
                switch (value.level) {
                    case 1:
                        this.searchForm.classId = undefined
                        this.searchForm.gradeId = value.id
                        break

                    case 2:
                        this.searchForm.classId = value.id
                        this.searchForm.gradeId = value.parentId
                        break

                    default:
                        this.searchForm.classId = undefined
                        this.searchForm.gradeId = undefined
                        break
                }

                this.getStudentsData(e.checked, value)
            },
            //获取左侧树结构数据
            getTreeData() {
                const params = {
                    extendId:this.reportInfo.id,
                    organizationId: this.reportInfo.organizationId,
                    ProjectCourseConfigIds:this.$store.getters['organization/getReportCourse'],
                }
                this.tableRelevant.tableLoading = true
                this.$http.GroupReport.projectcoursegradeclasstree(params).then(res => {
                    this.tree.key = Date.now()
                    this.tree.treeData = res.data.filter(f => f.level == 1).map(m => {
                        return {
                            ...m,
                            add: [],
                            del: [],
                            // disableCheckbox: this.courseInfo && this.courseInfo.complete,
                            // disabled: m.userCount <= 0,
                            scopedSlots: { title: 'title' },
                            children: res.data.filter(f => f.level == 2).map(m1 => ({
                                ...m1,
                                add: [],
                                del: [],
                                // disableCheckbox: this.courseInfo && this.courseInfo.complete,
                                // disabled: m1.userCount <= 0,
                                scopedSlots: { title: 'title' }
                            }))
                        }
                    })
                    this.tree.treeAllData = res.data.filter(f => f.level === 0).map(m => {
                        return {
                            ...m,
                            name: '全部',
                            add: [],
                            del: [],
                            // disableCheckbox: this.courseInfo && this.courseInfo.complete,
                            // disabled: m.userCount <= 0,
                            scopedSlots: { title: 'title' },
                            children: this.tree.treeData
                        }
                    })
                    try {
                        this.searchForm.gradeId = ''
                        this.searchForm.classId = ''
                    } catch (e) {
                        console.log(e)
                    }
                    this.getStudentsData('tree', this.tree.treeData[0])
                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
            //获取右侧学生列表数据
            getStudentsData(checked, json) {
                let params = {
                    organizationId: this.reportInfo.organizationId,
                    ProjectCourseConfigIds:this.$store.getters['organization/getReportCourse'],
                    pageIndex: 1,
                    pageSize: 99999,
                    ...this.searchForm
                }

                this.tableRelevant.tableLoading = true
                this.$http.GroupReport.GetPersonalCombinationReportUserPageList(params).then(res => {
                    this.tableRelevant.tableDataSource = res.data.items
                    if (typeof json === 'object') {
                        this.tree.treeDataValue = json
                    }
                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    #LookReport {
        height: calc(100vh - 105px);
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
    }

</style>
<style scoped>

#StepsSecond, #StepsSecond >>> .ant-spin-container {
        height: 100%;
    }

    .hideScroll {
        height: 100%;
        overflow-y: auto;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
    }

    .hideScroll::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }

    #StepsSecond >>> > .ant-spin-container {
        display: flex;
    }

    #StepsSecond .left {
        width: 260px;
        flex-shrink: 0;
        margin-right: 20px;
        border-right: 1px solid #ddd;
    }

    #StepsSecond .right {
        flex-grow: 1;
    }

    .ant-btn-link {
        margin-right: 15px;
    }

    .disabled {
        pointer-events: none;
    }
    /deep/ .ant-table-tbody .testClass{
        padding: 0 !important;
    }
    .self_td{
        height: 54px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        /* justify-content: center; */
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
